module.exports = __webpack_public_path__ + "img/Stemness-GBM_SPATA.561768e8.png";